<template>
  <div>
    <DataTable v-if="rates" :value="rates" :paginator="rates.length > 15" :rows="15" contextMenu class="bots-rates-table mx-auto w-full max-w-[50rem]">
      <Column class="bots-rates-table__column" field="countryName" :header="$t('global.country')">
        <template #body="{ data }">
          {{
            data.countryName
              ? data.countryName
              : $t("components.bmDefaultRates.otherCountries")
          }}
        </template>
      </Column>
      <Column class="bots-rates-table__column" field="rate" :header="$t('global.rate')">
        <template #body="{ data }"> {{ data.rate.toFixed(4) }} € </template>
      </Column>
      <Column class="bots-rates-table__column" field="mmcf" :header="$t('components.bmDefaultRates.mmf')">
        <template #body="{ data }"> {{ data.mmcf }} € </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import DataTable from "primevue/datatable";
import Column from "primevue/column";
const props = defineProps<{
    filterCountry?: string
}>()



const mockRates = [
  { countryName: "Poland", rate: 0.0138, mmcf: 100 },
  { countryName: "Ukraine", rate: 0.0577, mmcf: 100 },
  { countryName: "Germany", rate: 0.0138, mmcf: 100 },
  { countryName: "Romania", rate: 0.0138, mmcf: 100 },
  { countryName: "Czech Republic", rate: 0.0138, mmcf: 100 },
  { countryName: "Slovakia", rate: 0.0138, mmcf: 100 },
  { countryName: "Hungary", rate: 0.0138, mmcf: 100 },
  { countryName: "Bulgaria", rate: 0.02, mmcf: 100 },
  { countryName: "Croatia", rate: 0.0138, mmcf: 100 },
  { countryName: "Serbia", rate: 0.0138, mmcf: 100 },
  { countryName: "Moldova", rate: 0.0138, mmcf: 100 },
  { countryName: "Albania", rate: 0.0138, mmcf: 100 },
  { countryName: "Georgia", rate: 0.0115, mmcf: 100 },
  { countryName: "Armenia", rate: 0.0138, mmcf: 100 },
  { countryName: "Lithuania", rate: 0.0138, mmcf: 100 },
  { countryName: "Other countries", rate: 0.0137, mmcf: 100 }
];

const filterCountryRef = toRef(props, 'filterCountry');
const { rates } = useRatesTable('/rate/bot/default', mockRates, filterCountryRef);

</script>

<style lang="scss">
.bots-rates-table {
  width: 100%;

  & thead tr th:not(:first-child) div {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
  }

  &__column:first-child {
    text-align: left;

    & .p-column-header-content {
      justify-content: flex-start;
    }
  }

  &__column {
    text-align: right;

    & .p-column-header-content {
      display: flex;
      justify-content: flex-end;
    }
  }

  & .p-datatable-tbody {
    padding-top: 10px;
  }
}
</style>
